import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    details: string;
    labels: {
        /** Cancel button label */
        cancel: string;
        /** Confirm button label */
        confirm: string;
    };
    title: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Details explaining what happens when account is reactivated */
            details: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ResumePlanDialog.details?c=38rii77bd2z5c", defaultMessage: "You''ll be able to view, comment, upload, and share again. Your previous subscription will resume immediately." }));
                },
                enumerable: true,
                configurable: true
            },
            labels: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Cancel button label */
                        cancel: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ResumePlanDialog.labels.cancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Confirm button label */
                        confirm: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ResumePlanDialog.labels.confirm?c=lmf4jegcl01i", defaultMessage: "Continue" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Dialog title */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ResumePlanDialog.title?c=30ii1uszdcpr5", defaultMessage: "Reactivate Account?" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
